export default "__VITE_ASSET__fYPTJ7Nu__"